import { Maximize2, RotateCcw, Sparkles, X } from 'lucide-react';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useI18n } from '../../i18n';
import { useAssistant } from './AssistantContext';
import { Conversation } from './Conversation';

/** The questionnaire open in the current page, if any. */
function surveyIdFrom(pathname: string) {
  return /^\/surveys\/([0-9a-f-]{36})(\/|$)/i.exec(pathname)?.[1];
}

/**
 * Floating assistant button and panel, available on every page except the
 * Assistant page itself. It continues the same conversation as that page.
 */
export function AssistantPanel() {
  const { t } = useI18n();
  const { enabled, active, newChat } = useAssistant();
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  const nav = useNavigate();

  if (!enabled || loc.pathname === '/assistant') return null;

  return (
    <>
      {!open && (
        <button type="button" className="assistant-fab" onClick={() => setOpen(true)} aria-label={t('assistant.open')} title={t('assistant.open')}>
          <Sparkles />
        </button>
      )}
      {open && (
        <section className="assistant-panel" aria-label={t('assistant.title')}>
          <header className="assistant-head">
            <Sparkles aria-hidden />
            <h2>{t('assistant.title')}</h2>
            <div className="spacer" />
            {active && (
              <button type="button" className="icon-btn" onClick={newChat} aria-label={t('assistant.new_chat')} title={t('assistant.new_chat')}>
                <RotateCcw />
              </button>
            )}
            <button
              type="button"
              className="icon-btn"
              onClick={() => {
                setOpen(false);
                nav('/assistant');
              }}
              aria-label={t('assistant.open_full')}
              title={t('assistant.open_full')}
            >
              <Maximize2 />
            </button>
            <button type="button" className="icon-btn" onClick={() => setOpen(false)} aria-label={t('common.close')} title={t('common.close')}>
              <X />
            </button>
          </header>
          <Conversation variant="panel" surveyId={surveyIdFrom(loc.pathname)} />
        </section>
      )}
    </>
  );
}
